// extracted by mini-css-extract-plugin
module.exports = {"root":"DealsChart_root__8R0mP","impact":"DealsChart_impact__PcyH7"};